
interface InitialState {
    token: string;
    turnos: any[]; // o el tipo específico de turno
    users: any[];
    userTurnos: any[];
    detail: any[];
    ddjj: any[];
    userInfo: {};  
    turnosDisponibles:any[];
    linkPago: string;
    anexoDoc: any[];
    anexoUser: any[];
    tarjeta: any;
    contador:{};
    ddjjNuevo: any[];
    anexoNuevo: any[];
    consentimiento:{}
    consentimientoNuevo:{}
    comment:{}
    ddjjUserNuevo: any[]
}

  


const initialState: InitialState = {
    token: '',
    turnos: [],
    users:[],
    userTurnos:[],
    detail: [],
    ddjj: [],
    turnosDisponibles:[],
    linkPago:'',
    userInfo:{},
    anexoDoc:[],
    anexoUser:[],
    tarjeta:{},
    contador:{},
    ddjjNuevo: [],
    anexoNuevo: [],
    consentimiento:{},
    consentimientoNuevo:{},
    comment:{},
    ddjjUserNuevo:[]
};




const rootReducer = (state: InitialState = initialState, action:any):InitialState => {


    switch(action.type){

        case 'SIGN_UP': return {
            ...state
        }
        case 'SIGN_IN': return {
            ...state
        }
        case 'GET_TURNOS': return {
            ...state,
            turnos:action.payload
        }
        case 'GET_USERS': return {
            ...state,
            users: action.payload
        }
        case 'GET_USERS_DNI': return {
            ...state,
            users: action.payload
        }
        case 'GET_MYTURNOS': return {
            ...state,
            userTurnos: action.payload
        }
        case 'GET_DETAIL': return {
            ...state,
            detail: action.payload
        }
        case 'GET_DDJJ': return {
            ...state,
            ddjj: action.payload
        }
        case 'GET_DDJJ_USER': return {
            ...state,
            ddjj: action.payload
        }
        case 'GET_ANEXO_DOC': return {
            ...state,
            anexoDoc: action.payload
        }
        case 'GET_ANEXO_USER': return {
            ...state,
            anexoUser: action.payload
        }
        /* case 'TURNOS_BY_DOCTOR': return {
            ...state,
            doctorTurnos: action.payload
        } */
        case 'TURNOS_DISPONIBLES': return {
            ...state,
            turnosDisponibles: action.payload
        }
        case 'GET_PAGO': return {
            ...state,
            linkPago: action.payload.init_point
        }
        case 'GET_USER_INFO': return {
            ...state,
            userInfo: action.payload
        }
        case 'PAYMENT_METHOD': return {
            ...state,
            tarjeta: action.payload
        }
        case 'GET_CONTADOR': return {
            ...state,
            contador: action.payload
        }
        case 'GET_DDJJ_NUEVO': return {
            ...state,
            ddjjNuevo: action.payload
        }
        case 'GET_ANEXO_DOC_NUEVO': return {
            ...state,
            anexoNuevo: action.payload
        }
        case 'GET_CONSENTIMIENTO_USUARIO': return {
            ...state,
            consentimiento: action.payload
        }
        case 'GET_CONSENTIMIENTO_USUARIO_NUEVO': return {
            ...state,
            consentimientoNuevo: action.payload
        }
        case 'GET_CONSENTIMIENTO': return {
            ...state,
            consentimiento: action.payload
        }
        case 'GET_CONSENTIMIENTO_NUEVO': return {
            ...state,
            consentimientoNuevo: action.payload
        }
        case 'GET_COMMENT': return {
            ...state,
            comment: action.payload
        }
        case 'GET_DDJJ_USER_NUEVO': return {
            ...state,
            ddjjUserNuevo: action.payload
        }


        default:
            return state;
    }
}


export default rootReducer
